<template>
  <ion-page>
    <Background></Background>
    <WhiteBackground></WhiteBackground>
    <FabColumn>
      <QuitButton content_1="您所輸入的資料將不會被保留。" content_2="是否確認退出帳戶註冊？"></QuitButton>
    </FabColumn>

    <ion-content>
      <MainTitle text="設定用戶名稱"></MainTitle>
      <InputBox text="手提電話號碼" :value="showMobile" hideInput="true"></InputBox>
      <InputBox text="用戶名稱" placeholder="8-16 位英文或數字" @getValue="getName"></InputBox>
      <ConfirmButton text="繼續" position="relative" @click="registerName"></ConfirmButton>
    </ion-content>
  </ion-page>
</template>

<script>
import {IonContent, IonPage} from "@ionic/vue";
import Background from "../components/common/Background";
import WhiteBackground from "../components/common/WhiteBackground";
import MainTitle from "../components/common/MainTitle";
import QuitButton from "../components/common/QuitButton";
import common from "../common";
import ConfirmButton from "../components/common/ConfirmButton";
import router from "../router";
import InputBox from "../components/common/InputBox";

export default {
  name: "RegisterName",
  components: {
    InputBox,
    ConfirmButton,
    QuitButton,
    MainTitle,
    WhiteBackground,
    Background,
    IonPage,
    IonContent,
  },
  data() {
    return {
      mobile: '',
      showMobile: '',
      name: '',
    }
  },
  mounted() {
    this.mobile = this.$route.params.mobile;
    this.showMobile = common.splitMobile(this.mobile)
  },
  methods: {
    getName: function (value) {
      this.name = value
    },
    registerName: function () {
      if (!this.name) {
        common.showAlert('請輸入用戶名稱。');
        return;
      }
      const loading = common.showLoading();
      common.apiPostData('/registerName', {mobile: this.mobile, name: this.name}, false, loading).then(res => {
        if (res === false) {
          return false;
        }

        router.replace('/setPasswordByName/'+this.mobile+'/'+this.name)
      })
    }
  }
}
</script>

<style scoped>

</style>
